<template>

	<div class="section section-bold">
		<div class="section-title">
			{{title}}
			<span v-on:click="close" class="category-title-btn"><i class="material-icons md-14">close</i></span>
		</div>
		<form class="section-body">
			<div class="category">
				<div class="category-title overflow-hidden">
					LOT SIZE
				</div>
				<div class="property-row">
					<label>Minimum area <small>(leave empty for no min)</small></label>

					<div class="property-value-right">
						<input v-model.number="rec.lotSize.minArea" class="form-control form-control-sm" placeholder="area in ft²">
					</div>
				</div>
				<div class="property-row">
					<label>Maximum area</label>
					<div class="property-value-right">
						<input v-model.number="rec.lotSize.maxArea" class="form-control form-control-sm" placeholder="area in ft²">
					</div>
				</div>
				<div class="property-row">
					<label>Minimum width</label>
					<div class="property-value-right">
						<input v-model.number="rec.lotSize.minWidth" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Minimum width corner</label>
					<div class="property-value-right">
						<input v-model.number="rec.lotSize.minWidthCorner" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Minimum frontage</label>
					<div class="property-value-right">
						<input v-model.number="rec.lotSize.minFrontage" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Minimum depth</label>
					<div class="property-value-right">
						<input v-model.number="rec.lotSize.minDepth" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
			</div>
			<div class="category">
				<div class="category-title">DENSITY</div>
				<div class="property-row">
					<label>SF/DU</label>
					<div class="property-value-right property-locked">
						<input v-model.number="rec.density.sfDu" class="form-control form-control-sm" placeholder="ratio">
					</div>
				</div>
				<div class="property-row""> 
					<label>SF/DU note</label>
					<div class="property-value-right">
						<input v-model.string="rec.density.sfDuNote" class="form-control form-control-sm" placeholder="notations">
					</div>
				</div>
			</div>
			<div class="category">
				<div class="category-title">HEIGHT LIMIT</div>
				<div class="property-row">
					<label>Height maximum</label>
					<div class="property-value-right property-locked">
						<input v-model.number="rec.heightLimit.max" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Above enclosed parking</label>
					<div class="property-value-right property-locked">
						<input v-model.number="rec.heightLimit.aboveEnclosedParking" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Roof flat limit</label>
					<div class="property-value-right">
						<input v-model.number="rec.heightLimit.roofFlat" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Roof pitched limit</label>
					<div class="property-value-right">
						<input v-model.number="rec.heightLimit.roofPitched" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Height note</label>
					<div class="property-value-right">
						<input v-model.string="rec.heightLimit.note" class="form-control form-control-sm" placeholder="notation">
					</div>
				</div>
			</div>
			<div class="category">
				<div class="category-title">FLOOR TO AREA RATIO (FAR)</div>
				<div class="property-row">
					<label>FAR base</label>
					<div class="property-value-right">
						<input v-model.number="rec.far.base" class="form-control form-control-sm" placeholder="ratio">
					</div>
				</div>
				<div class="property-row">
					<label>FAR minimum</label>
					<div class="property-value-right">
						<input v-model.number="rec.far.min" class="form-control form-control-sm" placeholder="ratio">
					</div>
				</div>
				<div class="property-row">
					<label>FAR maximum</label>
					<div class="property-value-right">
						<input v-model.number="rec.far.max" class="form-control form-control-sm" placeholder="ratio">
					</div>
				</div>
				<div class="property-row">
					<label>FAR residential</label>
					<div class="property-value-right">
						<input v-model.number="rec.far.residential" class="form-control form-control-sm" placeholder="ratio">
					</div>
				</div>
				<div class="property-row">
					<label>FAR commercial</label>
					<div class="property-value-right">
						<input v-model.number="rec.far.commercial" class="form-control form-control-sm" placeholder="ratio">
					</div>
				</div>
				<div class="property-row">
					<label>FAR mixed</label>
					<div class="property-value-right">
						<input v-model.number="rec.far.mixed" class="form-control form-control-sm" placeholder="ratio">
					</div>
				</div>
				<div class="property-row">
					<label>FAR note</label>
					<div class="property-value-right">
						<input v-model.string="rec.far.note" class="form-control form-control-sm" placeholder="notation">
					</div>
				</div>
			</div>
			<div class="category">
				<div class="category-title">SETBACKS</div>
				<div class="property-row">
					<label>Front minimum</label>
					<div class="property-value-right">
						<input v-model.number="rec.setbacks.frontMin" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Front minimum note</label>
					<div class="property-value-right">
						<input v-model.string="rec.setbacks.frontMinNote" class="form-control form-control-sm" placeholder="notation">
					</div>
				</div>
				<div class="property-row">
					<label>Front maximum</label>
					<div class="property-value-right">
						<input v-model.number="rec.setbacks.frontMax" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Front maximum note</label>
					<div class="property-value-right">
						<input v-model.string="rec.setbacks.frontMaxNote" class="form-control form-control-sm" placeholder="notation">
					</div>
				</div>
				<div class="property-row">
					<label>Interior side</label>
					<div class="property-value-right">
						<input v-model.number="rec.setbacks.interiorSide" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Interior side note</label>
					<div class="property-value-right">
						<input v-model.string="rec.setbacks.interiorSideNote" class="form-control form-control-sm" placeholder="notation">
					</div>
				</div>
				<div class="property-row">
					<label>Street side</label>
					<div class="property-value-right">
						<input v-model.number="rec.setbacks.streetSide" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Street side note</label>
					<div class="property-value-right">
						<input v-model.string="rec.setbacks.streetSideNote" class="form-control form-control-sm" placeholder="notation">
					</div>
				</div>
				<div class="property-row">
					<label>Rear</label>
					<div class="property-value-right">
						<input v-model.number="rec.setbacks.rear" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Rear Alley</label>
					<div class="property-value-right">
						<input v-model.number="rec.setbacks.rearAlley" class="form-control form-control-sm" placeholder="distance in ft">
					</div>
				</div>
				<div class="property-row">
					<label>Rear note</label>
					<div class="property-value-right">
						<input v-model.string="rec.setbacks.rearNote" class="form-control form-control-sm" placeholder="notation">
					</div>
				</div>
				<div class="property-row">
					<label>General note</label>
					<div class="property-value-right">
						<input v-model.string="rec.setbacks.generalNote" class="form-control form-control-sm" placeholder="notation">
					</div>
				</div>
			</div>
			<div class="category">
				<div class="category-title">LOT COVERAGE</div>
				<div class="property-row">
					<label>Lot coverage minimum</label>
					<div class="property-value-right">
						<input v-model.number="rec.lotCoverage.min" class="form-control form-control-sm" placeholder="area in ft²">
					</div>
				</div>
				<div class="property-row">
					<label>Lot coverage maximum</label>
					<div class="property-value-right">
						<input v-model.number="rec.lotCoverage.max" class="form-control form-control-sm" placeholder="area in ft²">
					</div>
				</div>
				<div class="property-row">
					<label>Lot coverage note</label>
					<div class="property-value-right">
						<input v-model.string="rec.lotCoverage.note" class="form-control form-control-sm" placeholder="notation">
					</div>
				</div>
			</div>
		</form>
		<div class="section-footer">
			<button v-on:click="submit" class="btn btn-sm btn-primary float-right">{{submitLabel}}</button>
		</div>
	</div>
</template>
<script>

export default {
	name: 'regulation-form',
	created: function(){
		if (this.regulation) this.rec = JSON.parse(JSON.stringify(this.regulation))
		else this.rec = {
			lotSize:{},
			density:{},
			heightLimit:{},
			far:{},
			setbacks:{},
			lotCoverage:{}
		};
	},
	components:{
	},
	data:function(){
		return {
			rec:{}
		}
	},
	methods:{
		close:function(){
			this.$emit('close');
		},
		submit:function(){
			this.$emit('submit',this.rec);
		},
	},
	props:{
		regulation:{
			id: Number,
			zoningId: Number,
			lotSize: {
				minArea: Number,
				maxArea: Number,
				minWidth: Number,
				minWidthCorner: Number,
				minFrontage: Number,
				minDepth: Number
			},
			density: {
				sfDu: Number,
				sfDuNote: String
			},
			heightLimit:{
				max: Number,
				aboveEnclosedParking: Number,
				roofFlat: Number,
				roofPitched: Number,
				note: String    
			},
			far:{
				base: Number,
				min: Number,
				max: Number,
				residential: Number,
				commercial: Number,
				mixed: Number,
				note: String
			},
			setbacks:{
				frontMin: Number,
				frontMinNote: String,
				frontMax: Number,
				frontMaxNote: String,
				interiorSide: Number,
				interiorSideNote: String,
				streetSide: Number,
				streetSideNote: String,
				rear: Number,
				rearAlley: Number,
				rearNote: String,
				generalNote: String
			},
			lotCoverage:{
				min: Number,
				max: Number,
				note: String
			},
		},
		submitLabel:String,
		title:String,

	},
	watch:{
	}
}

</script>





// WEBPACK FOOTER //
// src/components/zoning/regulation-form.vue